var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPromotionPub(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 33") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5970279,
    cx: 35.4863,
    cy: 35.6047,
    r: 34.5,
    stroke: "white",
    fillOpacity: 0.20648,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1",
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mask-fill-icon",
    d: "m25.9353,25.89543a4.14,4.14 0 0 1 5.93,-0.19c1.44,1.63 1.62,3.34 0.28,5.06a4.13,4.13 0 0 1 -5.54,0.67c-1.85,-1.14 -2.01,-3.82 -0.67,-5.54zm18.22,14.06a3.81,3.81 0 0 0 -3.84,3.89a3.5,3.5 0 0 0 4,3.27a3.8,3.8 0 0 0 3.27,-4a3.3,3.3 0 0 0 -3.43,-3.16zm3.95,-12.62l-1.37,-1.56a1,1 0 0 0 -1.37,0l-3.12,2.47a111.39,111.39 0 0 0 -14,12.88l-3.27,3.63a1,1 0 0 0 0,1.37l1.37,1.55a1,1 0 0 0 1.37,0l2.65,-2.94a112.27,112.27 0 0 1 13.91,-13l3.83,-3.11a1,1 0 0 0 0,-1.29z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotionPub);
export default __webpack_public_path__ + "static/media/promotion-pub.def39c6b9794935659fa79d216b174b2.svg";
export { ForwardRef as ReactComponent };